/*
 * @Author: liuxw@codoon.com
 * @Date: 2021-07-12 17:35:34
 * @Last Modified by: liuxw@codoon.com
 * @Last Modified time: 2021-07-13 17:19:57
 * @Content:
 */

import React, { FC, memo, useCallback, useMemo } from "react";
import { connect } from "react-redux";
import GamblingEndModal from "..";
import {
  activityInfoSelector,
  gamblingCountSelector,
} from "../../../../store/common/selector";
import { isInCodoon } from "../../../../utils/bridge";
import "./index.less";
import { openCodoon } from "open-codoon";

const PREFIX = "GamblingEndRefundModal";

type IProps = {
  visible: boolean;
  onClose: () => void;
} & ReturnType<typeof mapStateToProps>;

const GamblingRefundModal: FC<IProps> = memo(
  ({ visible, onClose, gamblingCount, activityInfo }) => {
    const jumpToMoneyPage = useCallback(() => {
      if (!isInCodoon()) {
        // 唤醒咕咚个并进入当前活动页
        openCodoon(window.location.origin + window.location.pathname, "h5");
      } else {
        // 跳转至我的红包页面
        window.location.href = "https://www.codoon.com/h5/cash/index.html";
      }
    }, []);

    const refundPrice = useMemo((): string => {
      if (gamblingCount) {
        let refund = gamblingCount.user_refund || 0; // 分
        refund = refund / 100; // 元
        return refund.toFixed(2);
      } else {
        return "--";
      }
    }, [gamblingCount]);

    return (
      <GamblingEndModal
        visible={visible}
        onClose={onClose}
        className={PREFIX}
        footerBtnText={"马上查看"}
        onFooterBtnClick={jumpToMoneyPage}
      >
        <div>恭喜你！</div>
        <div>
          完成{activityInfo?.name || "挑战"}! 获得奖金&nbsp;
          <span className={`${PREFIX}-num`}>¥{refundPrice}</span>
        </div>
      </GamblingEndModal>
    );
  }
);

const mapStateToProps = (state: any) => {
  return {
    gamblingCount: gamblingCountSelector(state),
    activityInfo: activityInfoSelector(state),
  };
};

export default connect(mapStateToProps)(GamblingRefundModal);
